import { StrictEqualityComparer } from "../../shared/index.js";
export const contains = async (source, value, comparer = StrictEqualityComparer) => {
    for await (const item of source) {
        if (comparer(value, item)) {
            return true;
        }
    }
    return false;
};
